import { render, staticRenderFns } from "./NovelCover.vue?vue&type=template&id=24c41902&scoped=true"
import script from "./NovelCover.vue?vue&type=script&lang=ts"
export * from "./NovelCover.vue?vue&type=script&lang=ts"
import style0 from "./NovelCover.vue?vue&type=style&index=0&id=24c41902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c41902",
  null
  
)

export default component.exports